/* ============================================================
   KYOSHU FUSION — JS v6.0
   Panier custom (affichage) + Shopify Cart Ajax (checkout)
   ============================================================ */

var KF = {
  cart: [],
  delivery: false,
  DELIVERY_FEE: 3.90,

  fmt: function(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  },

  /* ── Ajouter un article (affichage local + Shopify Ajax) ── */
  add: function(name, price, cat, variantId) {
    var p = parseFloat(price);
    if (!name || isNaN(p)) return;

    /* 1. Mise à jour affichage local */
    var found = false;
    for (var i = 0; i < KF.cart.length; i++) {
      if (KF.cart[i].name === name) { KF.cart[i].qty++; found = true; break; }
    }
    if (!found) KF.cart.push({ name: name, price: p, cat: cat || '', qty: 1, variantId: variantId || null });
    KF.render();
    KF.openCart();

    /* 2. Synchroniser avec le panier Shopify (si variantId disponible) */
    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).catch(function() { /* silencieux — l'affichage local suffit */ });
    }
  },

  /* ── Modifier quantité ── */
  changeQty: function(name, delta) {
    for (var i = 0; i < KF.cart.length; i++) {
      if (KF.cart[i].name === name) {
        KF.cart[i].qty += delta;
        /* Sync Shopify si on a le variantId */
        if (KF.cart[i].variantId) {
          var newQty = Math.max(0, KF.cart[i].qty);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: KF.cart[i].variantId, quantity: newQty })
          }).catch(function() {});
        }
        if (KF.cart[i].qty <= 0) KF.cart.splice(i, 1);
        break;
      }
    }
    KF.render();
  },

  /* ── Checkout Shopify ── */
  checkout: function() {
    var btn = document.getElementById('checkoutBtn');

    /* Si tous les articles ont un variantId → panier Shopify déjà sync → checkout direct */
    var allSynced = KF.cart.length > 0 && KF.cart.every(function(i) { return !!i.variantId; });
    if (allSynced) {
      window.location.href = '/checkout';
      return;
    }

    /* Sinon : construire le panier Shopify depuis zéro via /cart/clear + /cart/add */
    if (btn) { btn.disabled = true; btn.textContent = 'Chargement…'; }

    var itemsWithVariant = KF.cart.filter(function(i) { return !!i.variantId; });
    if (!itemsWithVariant.length) {
      /* Aucun variantId → rediriger quand même (articles sans variant Shopify) */
      window.location.href = '/checkout';
      return;
    }

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        var items = itemsWithVariant.map(function(i) {
          return { id: i.variantId, quantity: i.qty };
        });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        window.location.href = '/checkout';
      });
  },

  openCart: function() {
    var d = document.getElementById('cartDrawer');
    if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  },

  closeCart: function() {
    var d = document.getElementById('cartDrawer');
    if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
  },

  render: function() {
    var body   = document.getElementById('cartBody');
    var footer = document.getElementById('cartFooter');
    var total  = document.getElementById('cartTotal');
    var waLink = document.getElementById('cartWALink');
    if (!body) return;

    /* Badges */
    var count = 0;
    for (var i = 0; i < KF.cart.length; i++) count += KF.cart[i].qty;
    document.querySelectorAll('.cart-trigger__count').forEach(function(b) { b.textContent = count; });

    if (!KF.cart.length) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<span class="cart-drawer__empty-icon">融</span>' +
          '<p class="cart-drawer__empty-title">Votre commande est vide</p>' +
          '<p class="cart-drawer__empty-sub">Explorez notre carte pour commencer</p>' +
        '</div>';
      if (footer) footer.hidden = true;
      return;
    }

    var subtotal = 0;
    var html = '';
    for (var i = 0; i < KF.cart.length; i++) {
      var item = KF.cart[i];
      var line = item.price * item.qty;
      subtotal += line;
      var safeKey = item.name.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
      html +=
        '<div class="cart-item">' +
          '<span class="cart-item__name">' + item.name + '</span>' +
          '<div class="cart-item__qty">' +
            '<button class="qty-btn" onclick="KF.changeQty(\'' + safeKey + '\',-1)" aria-label="Moins">&#8722;</button>' +
            '<span class="qty-num">' + item.qty + '</span>' +
            '<button class="qty-btn" onclick="KF.changeQty(\'' + safeKey + '\',1)" aria-label="Plus">+</button>' +
          '</div>' +
          '<span class="cart-item__price">' + KF.fmt(line) + '</span>' +
        '</div>';
    }
    body.innerHTML = html;

    var grand = subtotal + (KF.delivery ? KF.DELIVERY_FEE : 0);
    if (total)  total.textContent = KF.fmt(grand);
    if (footer) footer.hidden = false;

    /* WhatsApp link */
    if (waLink) {
      var addrEl = document.getElementById('deliveryAddress');
      var addr   = addrEl ? addrEl.value.trim() : '';
      var lines  = KF.cart.map(function(i) {
        return i.qty + 'x ' + i.name + ' — ' + KF.fmt(i.price * i.qty);
      }).join('\n');
      var msg = 'Bonjour Kyoshu Fusion 🍣\n\nCommande :\n\n' + lines +
                '\n\nSous-total : ' + KF.fmt(subtotal);
      if (KF.delivery) {
        msg += '\nLivraison : +' + KF.fmt(KF.DELIVERY_FEE);
        msg += addr ? '\n🚚 Adresse : ' + addr : '\n🚚 Adresse à préciser';
      } else {
        msg += '\n\n🏪 Sur place / À emporter';
      }
      msg += '\n\n💳 Acompte 30-50% possible pour confirmer.';
      msg += '\n\nTotal : ' + KF.fmt(grand) + '\n\nMerci !';
      waLink.href = 'https://wa.me/33629767048?text=' + encodeURIComponent(msg);
    }
  }
};

/* ── INIT ─────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {

  /* Fermeture panier */
  var overlay  = document.getElementById('cartOverlay');
  var closeBtn = document.getElementById('cartClose');
  if (overlay)  overlay.addEventListener('click',  function() { KF.closeCart(); });
  if (closeBtn) closeBtn.addEventListener('click', function() { KF.closeCart(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') KF.closeCart(); });

  /* Ouverture panier */
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-trigger')) KF.openCart();
  });

  /* Checkout bouton */
  var checkoutBtn = document.getElementById('checkoutBtn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function(e) {
      e.preventDefault();
      KF.checkout();
    });
  }

  /* Livraison */
  var delivChk  = document.getElementById('deliveryCheck');
  var delivWrap = document.getElementById('deliveryAddressWrap');
  var delivAddr = document.getElementById('deliveryAddress');
  if (delivChk) {
    delivChk.addEventListener('change', function() {
      KF.delivery = delivChk.checked;
      if (delivWrap) delivWrap.hidden = !KF.delivery;
      KF.render();
    });
  }
  if (delivAddr) delivAddr.addEventListener('input', function() { KF.render(); });

  /* ── BOUTONS AJOUTER AU PANIER ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var name      = btn.getAttribute('data-product-name');
    var price     = btn.getAttribute('data-product-price');
    var cat       = btn.getAttribute('data-product-cat') || '';
    var variantId = btn.getAttribute('data-variant-id') || null;

    if (!name || price === null || price === '') return;

    /* Feedback visuel */
    var labelEl  = btn.querySelector('span') || btn;
    var origText = labelEl.textContent;
    btn.disabled = true;
    labelEl.textContent = '✓';
    KF.add(name, price, cat, variantId);
    setTimeout(function() {
      labelEl.textContent = origText;
      btn.disabled = false;
    }, 1200);
  });

  /* Header scroll */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function() { header.classList.toggle('is-scrolled', window.scrollY > 48); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Scroll reveal */
  var revEls = document.querySelectorAll('.reveal');
  if (revEls.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.05 });
      revEls.forEach(function(el) { io.observe(el); });
    } else {
      revEls.forEach(function(el) { el.classList.add('is-visible'); });
    }
    setTimeout(function() {
      document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('is-visible'); });
    }, 600);
  }

  /* Curseur custom */
  var isMobile = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (!isMobile) {
    var dot  = document.getElementById('kfCur');
    var ring = document.getElementById('kfRing');
    if (dot && ring) {
      var mx = 0, my = 0, rx = 0, ry = 0;
      document.addEventListener('mousemove', function(e) {
        mx = e.clientX; my = e.clientY;
        dot.style.left = mx + 'px'; dot.style.top = my + 'px';
      }, { passive: true });
      (function tick() {
        rx += (mx - rx) * 0.11; ry += (my - ry) * 0.11;
        ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
        requestAnimationFrame(tick);
      })();
      var HOVER = 'a,button,[role="button"],[data-add-to-cart],.cart-trigger,.btn';
      document.addEventListener('mouseover', function(e) {
        if (e.target.closest(HOVER)) { dot.classList.add('is-hover'); ring.classList.add('is-hover'); }
      });
      document.addEventListener('mouseout', function(e) {
        if (e.target.closest(HOVER)) { dot.classList.remove('is-hover'); ring.classList.remove('is-hover'); }
      });
    }
  }

});

window.KFCartAPI = { add: KF.add, changeQty: KF.changeQty };

/* ══════════════════════════════════════════════
   MODAL PRODUIT PREMIUM — KYOSHU v9
   ══════════════════════════════════════════════ */

KF.modal = (function() {
  var modal     = null;
  var overlay   = null;
  var closeBtn  = null;
  var imgEl     = null;
  var phEl      = null;
  var catEl     = null;
  var titleEl   = null;
  var priceEl   = null;
  var descEl    = null;
  var qtyNum    = null;
  var qtyMinus  = null;
  var qtyPlus   = null;
  var addBtn    = null;
  var subtotalEl= null;

  var currentProduct = null;
  var currentQty     = 1;

  function init() {
    modal = document.getElementById('productModal');
    if (!modal) return;

    overlay  = modal.querySelector('.product-modal__overlay');
    closeBtn = modal.querySelector('.product-modal__close');
    imgEl    = modal.querySelector('.product-modal__img');
    phEl     = modal.querySelector('.product-modal__media-ph');
    catEl    = modal.querySelector('.product-modal__cat');
    titleEl  = modal.querySelector('.product-modal__title');
    priceEl  = modal.querySelector('.product-modal__price');
    descEl   = modal.querySelector('.product-modal__desc');
    qtyNum   = modal.querySelector('.product-modal__qty-num');
    qtyMinus = modal.querySelector('.product-modal__qty-minus');
    qtyPlus  = modal.querySelector('.product-modal__qty-plus');
    addBtn   = modal.querySelector('.product-modal__add-btn');
    subtotalEl = modal.querySelector('.product-modal__subtotal');

    if (overlay)  overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (qtyMinus) qtyMinus.addEventListener('click', function() { setQty(currentQty - 1); });
    if (qtyPlus)  qtyPlus.addEventListener('click',  function() { setQty(currentQty + 1); });
    if (addBtn)   addBtn.addEventListener('click', confirmAdd);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });
  }

  function open(product) {
    if (!modal) return;
    currentProduct = product;
    currentQty = 1;

    /* Image */
    if (imgEl) {
      if (product.image) {
        imgEl.src = product.image;
        imgEl.alt = product.name;
        imgEl.style.display = 'block';
        if (phEl) phEl.style.display = 'none';
      } else {
        imgEl.style.display = 'none';
        if (phEl) {
          phEl.style.display = 'flex';
          phEl.textContent = product.icon || '🍣';
        }
      }
    }

    if (catEl)   catEl.textContent   = product.cat || '';
    if (titleEl) titleEl.textContent = product.name || '';
    if (priceEl) priceEl.textContent = KF.fmt(product.price);
    if (descEl)  descEl.innerHTML    = product.desc || '';

    updateQtyDisplay();

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    currentProduct = null;
  }

  function setQty(n) {
    currentQty = Math.max(1, Math.min(99, n));
    updateQtyDisplay();
  }

  function updateQtyDisplay() {
    if (qtyNum) qtyNum.textContent = currentQty;
    if (subtotalEl && currentProduct) {
      var sub = currentProduct.price * currentQty;
      subtotalEl.innerHTML = 'Sous-total&nbsp;: <strong>' + KF.fmt(sub) + '</strong>';
    }
  }

  function confirmAdd() {
    if (!currentProduct) return;
    /* Ajoute la quantité sélectionnée */
    for (var i = 0; i < currentQty; i++) {
      KF.add(currentProduct.name, currentProduct.price, currentProduct.cat, currentProduct.variantId, null);
    }
    /* Feedback visuel sur le bouton */
    if (addBtn) {
      var orig = addBtn.innerHTML;
      addBtn.innerHTML = '<span>✓ Ajouté</span>';
      addBtn.style.background = '#BF9B5A';
      addBtn.style.color = '#040302';
      setTimeout(function() {
        addBtn.innerHTML = orig;
        addBtn.style.background = '';
        addBtn.style.color = '';
        close();
      }, 900);
    }
  }

  return { init: init, open: open, close: close };
})();

/* ── TRIGGER MODAL depuis les cartes ── */
document.addEventListener('DOMContentLoaded', function() {
  KF.modal.init();

  /* Délégation sur les cartes produits */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-open-modal]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    KF.modal.open({
      name:      trigger.dataset.productName      || '',
      price:     parseFloat(trigger.dataset.productPrice) || 0,
      cat:       trigger.dataset.productCat       || '',
      desc:      trigger.dataset.productDesc      || '',
      image:     trigger.dataset.productImage     || '',
      icon:      trigger.dataset.productIcon      || '🍣',
      variantId: trigger.dataset.variantId        || null
    });
  });
});


/* ═══════════════════════════════════════════════════════════════
   KYOSHU FUSION — PAGE COMMANDE PREMIUM
   Lecture du panier KF + formulaire + WhatsApp pré-rempli
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  var WHATSAPP_NUMBER = '33629767048';
  var DELIVERY_FEE    = 3.90;
  var selectedCovers  = 1;
  var selectedMode    = 'sur_place';
  var waHref          = '';

  /* ── Attendre le DOM ── */
  document.addEventListener('DOMContentLoaded', function() {
    if (!document.getElementById('KFCheckout')) return;

    initDateMin();
    initCovers();
    initModeCards();
    renderRecap();
    bindSubmit();
    bindConfirmButtons();
    initFieldAnimations();
  });

  /* ── Date min = aujourd'hui ── */
  function initDateMin() {
    var dateInput = document.getElementById('kfDate');
    if (!dateInput) return;
    var today = new Date();
    var yyyy  = today.getFullYear();
    var mm    = String(today.getMonth() + 1).padStart(2, '0');
    var dd    = String(today.getDate()).padStart(2, '0');
    dateInput.min = yyyy + '-' + mm + '-' + dd;
    dateInput.value = yyyy + '-' + mm + '-' + dd;
  }

  /* ── Sélecteur de couverts ── */
  function initCovers() {
    var btns = document.querySelectorAll('.kfco-cover-btn');
    var hidden = document.getElementById('kfCovers');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        btns.forEach(function(b) { b.classList.remove('kfco-cover-btn--active'); });
        btn.classList.add('kfco-cover-btn--active');
        selectedCovers = btn.dataset.covers;
        if (hidden) hidden.value = selectedCovers;
      });
    });
  }

  /* ── Mode cards (radio visuel) ── */
  function initModeCards() {
    var cards = document.querySelectorAll('.kfco-mode-card');
    var delivWrap = document.getElementById('kfcoDeliveryAddress');
    var delivRowRecap = document.getElementById('kfcoDeliveryRow');

    cards.forEach(function(card) {
      var radio = card.querySelector('input[type="radio"]');
      if (!radio) return;

      card.addEventListener('click', function() {
        cards.forEach(function(c) { c.classList.remove('kfco-mode-card--active'); });
        card.classList.add('kfco-mode-card--active');
        radio.checked = true;
        selectedMode = radio.value;

        /* Livraison — afficher champ adresse + ligne fee */
        var isDelivery = (selectedMode === 'livraison');
        if (delivWrap) delivWrap.style.display = isDelivery ? 'block' : 'none';
        if (delivRowRecap) delivRowRecap.style.display = isDelivery ? 'flex' : 'none';

        /* Mettre à jour total */
        updateTotals();
      });
    });
  }

  /* ── Rendu récapitulatif ── */
  function renderRecap() {
    var itemsEl   = document.getElementById('kfcoItems');
    var emptyEl   = document.getElementById('kfcoEmpty');
    var dividerEl = document.getElementById('kfcoDivider');
    var feesEl    = document.getElementById('kfcoFees');
    var totalEl   = document.getElementById('kfcoTotal');
    if (!itemsEl) return;

    var cart = (typeof KF !== 'undefined' && KF.cart) ? KF.cart : [];

    if (!cart.length) {
      if (emptyEl) emptyEl.style.display = 'flex';
      if (dividerEl) dividerEl.style.display = 'none';
      if (feesEl) feesEl.style.display = 'none';
      if (totalEl) totalEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    /* Supprimer anciens items (pas l'empty) */
    var oldItems = itemsEl.querySelectorAll('.kfco-recap-item');
    oldItems.forEach(function(el) { el.remove(); });

    /* Ajouter items */
    cart.forEach(function(item) {
      var div = document.createElement('div');
      div.className = 'kfco-recap-item';
      div.innerHTML =
        '<span class="kfco-recap-item__qty">' + item.qty + '</span>' +
        '<span class="kfco-recap-item__name">' + escHtml(item.name) + '</span>' +
        '<span class="kfco-recap-item__price">' + fmt(item.price * item.qty) + '</span>';
      itemsEl.appendChild(div);
    });

    if (dividerEl) dividerEl.style.display = 'block';
    if (feesEl) feesEl.style.display = 'flex';
    if (totalEl) totalEl.style.display = 'flex';

    updateTotals();
  }

  function updateTotals() {
    var cart = (typeof KF !== 'undefined' && KF.cart) ? KF.cart : [];
    var subtotal = cart.reduce(function(s, i) { return s + i.price * i.qty; }, 0);
    var delivery = (selectedMode === 'livraison') ? DELIVERY_FEE : 0;
    var total = subtotal + delivery;

    var subEl   = document.getElementById('kfcoSubtotal');
    var totEl   = document.getElementById('kfcoTotalAmount');
    if (subEl) subEl.textContent = fmt(subtotal);
    if (totEl) totEl.textContent = fmt(total);
  }

  /* ── Bind submit ── */
  function bindSubmit() {
    var btn = document.getElementById('kfcoSubmit');
    if (!btn) return;
    btn.addEventListener('click', function() {
      if (!validateForm()) return;
      buildAndShowConfirm();
    });
  }

  /* ── Validation légère ── */
  function validateForm() {
    var prenom = document.getElementById('kfPrenom');
    var phone  = document.getElementById('kfPhone');
    var date   = document.getElementById('kfDate');
    var heure  = document.getElementById('kfHeure');

    var errors = [];
    if (!prenom || !prenom.value.trim()) errors.push(prenom);
    if (!phone  || !phone.value.trim())  errors.push(phone);
    if (!date   || !date.value)          errors.push(date);
    if (!heure  || !heure.value === '')  errors.push(heure);

    /* Enlever anciens états d'erreur */
    document.querySelectorAll('.kfco-input--error').forEach(function(el) {
      el.classList.remove('kfco-input--error');
    });

    if (errors.length) {
      errors.forEach(function(el) {
        if (el) {
          el.classList.add('kfco-input--error');
          el.focus();
        }
      });
      /* Shake le bouton */
      var btn = document.getElementById('kfcoSubmit');
      if (btn) {
        btn.classList.add('kfco-submit-btn--shake');
        setTimeout(function() { btn.classList.remove('kfco-submit-btn--shake'); }, 600);
      }
      return false;
    }
    return true;
  }

  /* ── Construire le message WhatsApp et afficher confirm ── */
  function buildAndShowConfirm() {
    var cart = (typeof KF !== 'undefined' && KF.cart) ? KF.cart : [];

    /* Données form */
    var prenom   = val('kfPrenom');
    var nom      = val('kfNom');
    var phone    = val('kfPhone');
    var email    = val('kfEmail');
    var date     = formatDate(val('kfDate'));
    var heure    = val('kfHeure');
    var adresse  = val('kfAddress');
    var allergies= val('kfAllergies');
    var notes    = val('kfNotes');

    var subtotal = cart.reduce(function(s, i) { return s + i.price * i.qty; }, 0);
    var delivery = (selectedMode === 'livraison') ? DELIVERY_FEE : 0;
    var total    = subtotal + delivery;

    var modeLabel = {
      'sur_place': '🏮 Sur place',
      'a_emporter': '📦 À emporter',
      'livraison':  '🚚 Livraison'
    }[selectedMode] || selectedMode;

    /* Lignes articles */
    var lines = cart.length
      ? cart.map(function(i) {
          return '  • ' + i.qty + 'x ' + i.name + ' — ' + fmt(i.price * i.qty);
        }).join('\n')
      : '  (panier vide)';

    var msg =
      '✦ KYOSHU FUSION — Nouvelle réservation ✦\n\n' +
      '👤 ' + prenom + ' ' + nom + '\n' +
      '📱 ' + phone + '\n' +
      (email ? '✉️ ' + email + '\n' : '') +
      '\n━━━━━━━━━━━━━━━━━━━\n' +
      '📅 ' + date + ' à ' + heure + '\n' +
      '👥 ' + selectedCovers + ' couvert' + (selectedCovers > 1 ? 's' : '') + '\n' +
      modeLabel + '\n' +
      (selectedMode === 'livraison' && adresse ? '📍 ' + adresse + '\n' : '') +
      '\n━━━━━━━━━━━━━━━━━━━\n' +
      '🍣 Commande :\n' + lines + '\n' +
      '\nSous-total : ' + fmt(subtotal) +
      (delivery ? '\nLivraison  : +' + fmt(delivery) : '') +
      '\nTOTAL      : ' + fmt(total) +
      '\n━━━━━━━━━━━━━━━━━━━\n' +
      (allergies ? '⚠️ Allergies : ' + allergies + '\n' : '') +
      (notes     ? '💬 Note : ' + notes + '\n' : '') +
      '\nMerci de confirmer ma réservation 🙏';

    waHref = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(msg);

    /* Afficher montant dans confirm */
    var numEl = document.getElementById('kfcoConfirmNum');
    if (numEl) numEl.textContent = fmt(total);

    /* Ouvrir overlay confirm */
    var confirm = document.getElementById('kfcoConfirm');
    if (confirm) {
      confirm.classList.add('is-open');
      confirm.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  /* ── Boutons de l'overlay confirm ── */
  function bindConfirmButtons() {
    var goBtn   = document.getElementById('kfcoConfirmGo');
    var backBtn = document.getElementById('kfcoConfirmBack');
    var confirm = document.getElementById('kfcoConfirm');

    if (goBtn) {
      goBtn.addEventListener('click', function() {
        if (waHref) window.open(waHref, '_blank', 'noopener,noreferrer');
      });
    }
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        if (confirm) {
          confirm.classList.remove('is-open');
          confirm.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });
    }
  }

  /* ── Animations d'apparition sur les champs ── */
  function initFieldAnimations() {
    var fields = document.querySelectorAll('.kfco-block');
    if (!('IntersectionObserver' in window)) {
      fields.forEach(function(f) { f.style.opacity = '1'; f.style.transform = 'none'; });
      return;
    }
    /* Les blocs sont déjà animés via CSS animation + delay, pas besoin de IO ici */
  }

  /* ── Helpers ── */
  function fmt(n) {
    return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function escHtml(str) {
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    var parts = dateStr.split('-');
    if (parts.length !== 3) return dateStr;
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }

})();

/* ── CSS dynamique pour erreur et shake ── */
(function() {
  var style = document.createElement('style');
  style.textContent =
    '.kfco-input--error { border-color: #c0392b !important; }' +
    '.kfco-input--error + .kfco-input-line { background: #c0392b; width: 100% !important; }' +
    '@keyframes kfcoShake {' +
      '0%,100%{transform:translateX(0)}' +
      '20%{transform:translateX(-6px)}' +
      '40%{transform:translateX(6px)}' +
      '60%{transform:translateX(-4px)}' +
      '80%{transform:translateX(4px)}' +
    '}' +
    '.kfco-submit-btn--shake { animation: kfcoShake .5s ease; }';
  document.head.appendChild(style);
})();
